interface Props {
  color?: string;
}

const TwitterIcon: React.FC<Props> = ({ color = "white" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5798 17.3333L11.7164 8.78535L11.7264 8.79335L17.0131 2.66669H15.2464L10.9398 7.65335L7.51976 2.66669H2.88643L8.36042 10.6474L8.35976 10.6467L2.58643 17.3333H4.35309L9.14109 11.7854L12.9464 17.3333H17.5798ZM6.81976 4.00002L15.0464 16H13.6464L5.41309 4.00002H6.81976Z"
        fill={color}
      />
    </svg>
  );
};

export default TwitterIcon;
